export default __webpack_public_path__ + "e75b11c.png";